@if (infoMessage?.showMessage) {
  <app-information-message [message]="infoMessage"></app-information-message>
}
<section>
  <div class="font-heading-1 mb-08">{{ headline }}</div>

  <p class="mb-16">{{ information }}</p>

  <section>
    <button [rebrand]="true" [stbButton]="'primary'" (click)="reloadPage()">
      {{ buttonText }}
    </button>
  </section>

  <img alt [src]="image" />
</section>
